export enum StockItemType {
  Ingredient = 'i',
  Product = 'p',
}
